import LoginRequired from "./LoginRequired";
import SubscribeScene from './SubscribeScene';
import { useState } from 'react';
import { useStore, useSelector } from 'react-redux';
import G from './Getters';
import RefreshAccountMessage from './RefreshAccountMessage';
import RefreshAccountButton from './RefreshAccountButton';

import SubscriptionActivityMessage from './SubscriptionActivityMessage';


import CollapsibleSection from './CollapsibleSection';

import CancelSubscription from './CancelSubscription';

export default function SubscriptionSettings(){

  //const [showPricing, setShowPricing] = useState(true);


  const store = useStore();
  const state = store.getState();


  if( !G.isLoggedIn(state) ){
    return <LoginRequired/>
  }


  const refreshNeeded = state.warnings.subscriptionRefereshNeeded;

  const isCancelled=G.isSubscriptionCancelled(state,{productId:"sciugoMain"});
  const subscriptionActivityMessage = G.getSubscriptionActivityMessage(state,{productId:"sciugoMain"});
  const productsWithExpiredSubscriptions=G.getProductsWithExpiredSubscriptions(state);
  const expiry = G.getSubscriptionExpiry(state);

  let inPreTrial = expiry === "never";

  let pricingDefaultOpen = inPreTrial || productsWithExpiredSubscriptions.includes("sciugoMain");


  let subActivityComponent = <SubscriptionActivityMessage {...{
    subscriptionActivityMessage,
    productsWithExpiredSubscriptions
  }}/>

    


    return (
      <div 
        class="sg-col text-body"
        style={{

          minHeight:0,
          width:'100%',
          borderBottom:'1px solid #ccc',
          position:'relative',
          overflowY:'auto',
        }}>

        <div 
          info={"subscriptionActivityMessage"} class="sg-row v-align">
          {subActivityComponent}
        </div>


        <div style={{ padding:10, }}
          class="sg-row v-center">
          {refreshNeeded && (
            <RefreshAccountMessage/>
          )}

          <div class="flex-expand"/>
          <RefreshAccountButton/>

        </div>


        <CollapsibleSection {...{
          defaultOpen:pricingDefaultOpen,
          sectionTitle:"Upgrade plans",
        }}>
          <SubscribeScene background={"#ddd"}/>
        </CollapsibleSection>

        {!inPreTrial && !isCancelled && <CollapsibleSection {...{
          sectionTitle:"Cancel renewal"
        }}>

          <CancelSubscription/> 
        </CollapsibleSection>}


      </div>



    )
}
